import { createAction, props } from '@ngrx/store';
import { CardType, OrganizationPaymentAccount, PaymentAccount } from '@uzurv/clara';
import { ApplicationException, HttpException } from '@uzurv/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MobilityManagerPaymentAccountDialog } from '../../components/dialogs/payment-account-dialog/mobility-manager/mobility-manager-payment-account-dialog.dialog';
import { Tab } from '../../services/tab/tab.service';
import { MobilityManagerState } from './mobility-manager.reducer';

export const Start = createAction('[Mobility Manager] Start', props<Tab<MobilityManagerState>>());

export const RestoreState = createAction('[Mobility Manager] Restore State', props<{ state: MobilityManagerState }>());

export const OpenAddOrganizationPaymentAccountDialog = createAction('[Mobility Manager] Open Add Organization Payment Account Dialog');

export const OpenEditOrganizationPaymentAccountDialog = createAction(
  '[Mobility Manager] Open Edit Organization Payment Account Dialog',
  props<{ organizationPaymentAccount: OrganizationPaymentAccount }>()
);

export const OpenDeleteOrganizationPaymentAccountDialog = createAction(
  '[Mobility Manager] Open Delete Organization Payment Account Dialog',
  props<{ organizationPaymentAccount: OrganizationPaymentAccount }>()
);

export const OpenDefaultOrganizationPaymentAccountDialog = createAction(
  '[Mobility Manager] Open Default Organization Payment Account Dialog',
  props<{ organizationPaymentAccount: OrganizationPaymentAccount }>()
);

export const OpenOrganizationPaymentAccountNeededDialog = createAction(
  '[Mobility Manager] Open Organization Payment Account Needed Dialog'
);

export const OpenDefaultOrganizationPaymentAccountExpiredDialog = createAction(
  '[Mobility Manager] Open Default Organization Payment Account Expired Dialog',
  props<{ organizationPaymentAccount: OrganizationPaymentAccount }>()
);

export const GetOrganizationPaymentAccounts = createAction('[Mobility Manager] Get Organization Payment Accounts');

export const GetOrganizationPaymentAccountSuccess = createAction(
  '[Mobility Manager] Get Organization Payment Account success',
  props<{ organizationPaymentAccounts: Array<OrganizationPaymentAccount> }>()
);

export const GetOrganizationPaymentAccountFail = createAction(
  '[Mobility Manager] Get Organization Payment account fail',
  props<{ error: HttpException | ApplicationException }>()
);

export const GetCardTypes = createAction('[Mobility Manager] Get Card Types');

export const GetCardTypesSuccess = createAction('[Mobility Manager] Get Card Types Success', props<{ cardTypes: Array<CardType> }>());

export const GetCardTypesFail = createAction('[Mobility Manager] Get card types fail', props<{ error: HttpException }>());

export const CreateOrganizationPaymentAccount = createAction(
  '[Mobility Manager] Create Organization payment account',
  props<{ dialogRef: MatDialogRef<MobilityManagerPaymentAccountDialog>; organizationPaymentAccount: OrganizationPaymentAccount }>()
);

export const CreateOrganizationPaymentAccountSuccess = createAction(
  '[Mobility Manager] Create Organization Payment Sccount success',
  props<{ organizationPaymentAccount: OrganizationPaymentAccount }>()
);

export const CreateOrganizationPaymentAccountFail = createAction(
  '[Mobility Manager] Create  Organization Payment Account fail',
  props<{ error: HttpException | ApplicationException }>()
);

export const EditOrganizationPaymentAccount = createAction(
  '[Mobility Manager] Edit Organization Payment Account',
  props<{ dialogRef: MatDialogRef<MobilityManagerPaymentAccountDialog>; organizationPaymentAccount: OrganizationPaymentAccount }>()
);

export const EditOrganizationPaymentAccountSuccess = createAction(
  '[Mobility Manager] Edit Organization Payment Account success',
  props<{ organizationPaymentAccount: OrganizationPaymentAccount }>()
);

export const EditOrganizationPaymentAccountFail = createAction(
  '[Mobility Manager] Edit Organization Payment Account fail',
  props<{ error: HttpException | ApplicationException }>()
);

export const DeleteOrganizationPaymentAccount = createAction(
  '[Mobility Manager] Delete Organization Payment Account',
  props<{ organizationPaymentAccount: OrganizationPaymentAccount }>()
);

export const DeleteOrganizationPaymentAccountSuccess = createAction('[Mobility Manager] Delete Organization Payment Account success');

export const DeleteOrganizationPaymentAccountFail = createAction(
  '[Mobility Manager] Delete Organization Payment Account fail',
  props<{ error: HttpException | ApplicationException }>()
);

export const SetDefaultOrganizationPaymentAccount = createAction(
  '[Mobility Manager] Set default Organization Payment Account',
  props<{ organizationPaymentAccount: OrganizationPaymentAccount }>()
);

export const SetDefaultOrganizationPaymentAccountSuccess = createAction(
  '[Mobility Manager] Set default Organization Payment Account success'
);

export const SetDefaultOrganizationPaymentAccountFail = createAction(
  '[Mobility Manager] Set default Organization Payment Account fail',
  props<{ error: HttpException | ApplicationException }>()
);

export const Close = createAction('[Mobility Manager] Close');
